import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUIUserFavoriteModel } from "../../services/ui-personalization-data-service/Models";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { FavoriteMutationContextType } from "./Common";
import { keys } from "./Keys";

export type UseSaveUserFavoritesResultType = {
};

export type UseSaveUserFavoritesParameters = {
} & BaseUseMutationParameters<UseSaveUserFavoritesResultType, Array<IUIUserFavoriteModel>>;

export function useSaveUserFavorites({
    onError,
    onSuccess
}: UseSaveUserFavoritesParameters) {
    const queryClient = useQueryClient();

    return useMutation<UseSaveUserFavoritesResultType, RestError, Array<IUIUserFavoriteModel>, FavoriteMutationContextType>(
        async (favorites) => {
            await UIPersonalizationDataService.manageUserFavorites(favorites);

            return {
                //savedDescription: favorites.description
            };
        },
        {
            onMutate: async (_favorites: Array<IUIUserFavoriteModel>) => {

                await queryClient.cancelQueries(keys.all);

                const previousFavorites = queryClient.getQueryData<Array<IUIUserFavoriteModel>>(
                    keys.favoriteList()
                );

                queryClient.setQueryData<Array<IUIUserFavoriteModel>>(
                    keys.favoriteList(),
                    (favorites: Array<IUIUserFavoriteModel> | undefined) => {

                        // const existingFavorite = favorites?.find(f => f.id === favorites.id);

                        // return existingFavorite
                        //     ? favorites?.map(f => (f.id === favorites.id ? favorites : f)) ?? []
                        //     : [...favorites ?? [], favorites];
                        return favorites ?? [];
                    }
                );

                return {
                    previousFavorites: previousFavorites
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _favorite, context) => {

                if (error && context?.previousFavorites) {
                    queryClient.setQueryData<Array<IUIUserFavoriteModel>>(
                        keys.favoriteList(),
                        context?.previousFavorites
                    );
                }

                if (!error) {
                    queryClient.invalidateQueries(keys.favoriteList());

                    queryClient.refetchQueries(keys.favoriteList());
                }
            }
        }
    );
}
